import React, { useEffect, useState } from "react";
import PageContainer from "../../../components/PageContainer";
import CustosPrevistosService from "../../../services/api/CustosPrevistosService";
import ProjetosApiService from "../../../services/api/ProjetosApiService";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Table } from "react-bootstrap";
import { MdOutlineArrowBack } from "react-icons/md";
import { FiInfo } from 'react-icons/fi';
import UtilService from "../../../services/util";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, ReferenceLine, Area } from "recharts";

const formatDataToYYYYMM = (data) => {
    if (!data) return '';
    
    // Se for um objeto Date, converte para ISO string primeiro
    let dataString;
    if (data instanceof Date) {
        dataString = data.toISOString();
    } else {
        dataString = data.toString();
    }
    
    // Extrai ano e mês diretamente da string ISO para evitar problemas de timezone
    // Formato esperado: "2025-01-01T00:00:00.000Z" ou "2025-01-01" ou "2025-01"
    const partesData = dataString.split('-');
    
    if (partesData.length < 2) {
        // Fallback para Date se o formato não for reconhecido
        const date = new Date(data);
        if (isNaN(date.getTime())) {
            return '';
        }
        const ano = date.getUTCFullYear();
        const mes = String(date.getUTCMonth() + 1).padStart(2, '0');
        return `${ano}-${mes}`;
    }
    
    const ano = partesData[0];
    // Remove parte de hora se existir e garante que o mês tenha 2 dígitos
    const mesString = partesData[1].split('T')[0];
    const mes = String(parseInt(mesString, 10)).padStart(2, '0');
    
    // Valida se ano e mês são válidos
    if (isNaN(parseInt(ano, 10)) || isNaN(parseInt(mes, 10)) || parseInt(mes, 10) < 1 || parseInt(mes, 10) > 12) {
        // Fallback para Date
        const date = new Date(data);
        if (isNaN(date.getTime())) {
            return '';
        }
        const anoFallback = date.getUTCFullYear();
        const mesFallback = String(date.getUTCMonth() + 1).padStart(2, '0');
        return `${anoFallback}-${mesFallback}`;
    }
    
    return `${ano}-${mes}`;
};

function ResultadoAnualProjeto() {
    const [visiblePopup, setVisiblePopup] = useState(null);
    const [margemProjeto, setMargemProjeto] = useState([]);
    const [margemPrevistaPorcent, setMargemPrevistaPorcent] = useState("");
    const [selectedYear, setSelectedYear] = useState(0);
    const [dataSelectYear, setDataSelectYear] = useState([]);
    const [dataFormated, setDataFormated] = useState({});
    const [totaisPorAno, setTotaisPorAno] = useState({})
    const [totais, setTotais] = useState({
        receitaLiquidaTotal: 0,
        custoTotalRealTotal: 0,
        resultadoLiquidoTotal: 0,
        totalMargemLiquida: 0,
        totalMargemContribuicao: 0,
    });

    const popupStyle = {
        position: 'absolute',
        top: '-250%',
        left: '-70%',
        transform: 'translateX(-55%)',
        backgroundColor: '#e9e9e9',
        color: '#212529',
        border: '1px solid #dee2e6',
        borderRadius: '5px',
        padding: '5px 10px',
        zIndex: 1000,
        whiteSpace: 'nowrap',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        width: 'auto',
        fontWeight: 'normal'
    };

    const { key, radioPeriodo } = useParams();
    const location = useLocation();
    const { data } = location.state || {};
    const { dataInicial, dataFinal } = data || {};
    
    // Extrai ano diretamente da string ISO para evitar problemas de timezone
    const getAnoFromData = (dataString) => {
        if (!dataString) return new Date().getFullYear();
        const partesData = dataString.toString().split('-');
        if (partesData.length >= 1) {
            const ano = parseInt(partesData[0], 10);
            return isNaN(ano) ? new Date().getFullYear() : ano;
        }
        return new Date(dataString).getFullYear();
    };
    
    const ano = getAnoFromData(dataInicial);

    const handleMargemProjeto = async () => {
        try {
            let response;
    
            if (radioPeriodo === "data") {
                response = await ProjetosApiService.getMargemforPeriod(
                    formatDataToYYYYMM(dataInicial),
                    formatDataToYYYYMM(dataFinal),
                    key
                );
            } else {
                response = await ProjetosApiService.getMargemforYearAll(radioPeriodo, key);
            }
    
            const {
                result = [],
                totaisGerais = {},
                totaisPorAno = {}
            } = response?.data || {};
    
            const {
                receitaBrutaTotal = 0,
                faturamentoLiquidoRealTotal: receitaLiquidaTotal = 0,
                custoTotalRealTotal = 0,
                despesasOperacionaisTotal = 0,
                impostoSobreResultadosTotal = 0,
                resultadoLiquidoTotal = 0,
                margemLiquidaMensalTotal: totalMargemLiquida = 0,
                margemContribuicaoMensalTotal: totalMargemContribuicao = 0
            } = totaisGerais;

            setMargemProjeto(result);
            setTotais({
                receitaBrutaTotal,
                receitaLiquidaTotal,
                custoTotalRealTotal,
                despesasOperacionaisTotal,
                impostoSobreResultadosTotal,
                resultadoLiquidoTotal,
                totalMargemLiquida,
                totalMargemContribuicao
            });
            setTotaisPorAno(totaisPorAno);
    
        } catch (error) {
            console.error("Erro ao buscar margem do projeto:", error);
        }
    };
    
    const handleMargemPrevista = async () => {
        try {
            const resp = await CustosPrevistosService.findByProject(key);
            setMargemPrevistaPorcent(resp.data.margem_custo_projeto);
        } catch (err) {
            console.error("Erro ao buscar margem prevista", err)
        }
    };

    const exportDataInExcel = async () => {
        const header = [
            [
                'Período', 'Receita Bruta Real', 'Receita Líquida Real', 'Custo Total Real', 'Total em Impostos', 'Despesas Operacionais', 'Resultado Líquido', 'Margem Líquida Mensal', 'Margem de Contribuição Mensal'
            ]
        ];

        const transformData = (data) => {
            const monthsMapping = {
                "janeiro": "Janeiro",
                "fevereiro": "Fevereiro",
                "março": "Março",
                "abril": "Abril",
                "maio": "Maio",
                "junho": "Junho",
                "julho": "Julho",
                "agosto": "Agosto",
                "setembro": "Setembro",
                "outubro": "Outubro",
                "novembro": "Novembro",
                "dezembro": "Dezembro"
            };

            const monthOrder = [
                "janeiro", "fevereiro", "março", "abril", "maio", "junho",
                "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
            ];

            const transformedData = [];

            Object.keys(data).forEach((year) => {
                const orderedMonths = Object.keys(data[year]).sort((a, b) => {
                    return monthOrder.indexOf(a.split(' ')[0]) - monthOrder.indexOf(b.split(' ')[0]);
                });
        
                orderedMonths.forEach((month) => {
                    const report = data[year][month];
                    const rb = parseFloat(report.receita_bruta) || 0;
                    const rl = parseFloat(report.receita_liquida) || 0;
                    const totalImpostos = (rb - rl) + (parseFloat(report.imposto_sem_resultado) || 0);
                    transformedData.push({
                        mes: `${monthsMapping[month.split(' ')[0]]} ${year}`,
                        receita_bruta: rb,
                        receita_liquida: rl,
                        custo_venda: parseFloat(report.custo_venda),
                        total_impostos: totalImpostos,
                        despesas_operacionais: parseFloat(report.despesas_operacionais) || 0,
                        resultado_liquido: parseFloat(report.resultado_liquido) || 0,
                        margem_liquida: `${(parseFloat(report.margem_liquida) * 100).toFixed(2).replace('.', ',')}%`,
                        margem_contribuicao: `${(parseFloat(report.margem_contribuicao) * 100).toFixed(2).replace('.', ',')}%`
                    });
                });
            });

            return transformedData;
        };

        const periodoExport = dataInicial && dataFinal 
            ? `${formatDataToYYYYMM(dataInicial)} a ${formatDataToYYYYMM(dataFinal)}`
            : ano;
        UtilService.exportXls(transformData(dataFormated), `Resultado do Projeto: ${key} - ${periodoExport}`, header);
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (        
                <div
                    tabIndex="-1"
                    className="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom"
                    >
                    <div
                        className="recharts-default-tooltip"
                        style={{
                        margin: '0px',
                        padding: '10px',
                        backgroundColor: 'rgb(255, 255, 255)',
                        border: '1px solid rgb(204, 204, 204)',
                        whiteSpace: 'nowrap'
                        }}
                    >
                        <p className="recharts-tooltip-label" style={{ margin: '0px' }}>
                        {label}
                        </p>
                        <ul className="recharts-tooltip-item-list" style={{ padding: '0px', margin: '0px' }}>
                        <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: '#00c49f' }}>
                            <span className="recharts-tooltip-item-name">Receita Líquida</span>
                            <span className="recharts-tooltip-item-separator"> : </span>
                            <span className="recharts-tooltip-item-value">R$ {!isNaN(payload[0].value) ? parseFloat(payload[0].value).toLocaleString('pt-br') : "-" }</span>
                            <span className="recharts-tooltip-item-unit"></span>
                        </li>
                        <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: '#0088fe' }}>
                            <span className="recharts-tooltip-item-name">Custo Total</span>
                            <span className="recharts-tooltip-item-separator"> : </span>
                            <span className="recharts-tooltip-item-value">R$ {!isNaN(payload[1].value) ? parseFloat(payload[1].value).toLocaleString('pt-br') : "-" }</span>
                            <span className="recharts-tooltip-item-unit"></span>
                        </li>
                        <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: 'rgb(255, 115, 0)' }}>
                            <span className="recharts-tooltip-item-name">Margem Líquida</span>
                            <span className="recharts-tooltip-item-separator"> : </span>
                            <span className="recharts-tooltip-item-value">{!isNaN(payload[2].value) ? parseFloat(payload[2].payload.margem_liquida).toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 }) : "-" }</span>
                            <span className="recharts-tooltip-item-unit"></span>
                        </li>
                        <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: 'rgb(199, 177, 8)' }}>
                            <span className="recharts-tooltip-item-name">Margem de Contribuição</span>
                            <span className="recharts-tooltip-item-separator"> : </span>
                            <span className="recharts-tooltip-item-value">{!isNaN(payload[3].value) ? parseFloat(payload[3].value).toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 }) : "-" }</span>
                            <span className="recharts-tooltip-item-unit"></span>
                        </li>
                        </ul>
                    </div>
                </div>
            );
        }
    
        return null;
    };

    const actions = [
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: useHistory().goBack
        }
    ];

    useEffect(() => {
        handleMargemProjeto();
        handleMargemPrevista();
    }, []);


    useEffect(() => {
        dataFormatedForYear();
    }, [margemProjeto]);

    useEffect(() => {
        const anos = Object.keys(dataFormated).sort();
        
        if (anos.length > 0) {
            // Inicializa selectedYear com o último ano se ainda não foi definido ou se o ano atual não existe
            if (!selectedYear || selectedYear === 0 || !dataFormated[selectedYear]) {
                const ultimoAno = anos[anos.length - 1];
                setSelectedYear(ultimoAno);
            }
        }
    }, [dataFormated]);

    useEffect(() => {
        if (dataFormated[selectedYear] && selectedYear) {
            setDataSelectYear(processReportData(dataFormated[selectedYear]));
        }
    }, [selectedYear, dataFormated, margemPrevistaPorcent]);

    const dataFormatedForYear = () => {
        const dadosPorAno = margemProjeto.reduce((acc, item) => {
            // Usa data_inicio se disponível, caso contrário usa periodo_inicial
            const dataInicio = item.data_inicio || item.periodo_inicial;
            
            if (!dataInicio) {
                return acc;
            }
            
            // Extrai ano e mês diretamente da string ISO para evitar problemas de timezone
            // Formato esperado: "2025-01-01T00:00:00.000Z" ou "2025-01-01" ou "2025-01"
            const dataString = dataInicio.toString();
            const partesData = dataString.split('-');
            
            if (partesData.length < 2) {
                return acc;
            }
            
            const ano = parseInt(partesData[0], 10);
            const mes = parseInt(partesData[1], 10);
            
            if (isNaN(ano) || isNaN(mes) || mes < 1 || mes > 12) {
                return acc;
            }
            
            // Cria data em UTC para formatação do mês/ano
            const dataInicioDate = new Date(Date.UTC(ano, mes - 1, 1));
            const mesAno = dataInicioDate.toLocaleString('pt-BR', { month: 'long', year: 'numeric', timeZone: 'UTC' });
    
            if (!acc[ano]) {
                acc[ano] = {};
            }
    
            // Se não existe registro para este mês/ano ou se o novo registro é mais recente, atualiza
            const existingDataInicio = acc[ano][mesAno] ? (acc[ano][mesAno].data_inicio || acc[ano][mesAno].periodo_inicial) : null;
            
            if (!acc[ano][mesAno] || !existingDataInicio) {
                acc[ano][mesAno] = item;
            } else {
                // Compara datas extraindo ano/mês/dia diretamente da string
                const existingPartes = existingDataInicio.toString().split('-');
                const existingAno = parseInt(existingPartes[0], 10);
                const existingMes = parseInt(existingPartes[1], 10);
                const existingDia = existingPartes[2] ? parseInt(existingPartes[2].split('T')[0], 10) : 1;
                const itemDia = partesData[2] ? parseInt(partesData[2].split('T')[0], 10) : 1;
                
                // Compara: ano > mes > dia
                if (ano > existingAno || 
                    (ano === existingAno && mes > existingMes) || 
                    (ano === existingAno && mes === existingMes && itemDia > existingDia)) {
                    acc[ano][mesAno] = item;
                }
            }
    
            return acc;
        }, {});

        setDataFormated(dadosPorAno)
    }

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };
    
    const processReportData = (reportData) => {
        const getMonthIndex = (key) => {
            const months = {
                "janeiro": 1,
                "fevereiro": 2,
                "março": 3,
                "abril": 4,
                "maio": 5,
                "junho": 6,
                "julho": 7,
                "agosto": 8,
                "setembro": 9,
                "outubro": 10,
                "novembro": 11,
                "dezembro": 12
            };
            const month = key.split(" ")[0].toLowerCase();
            return months[month] || 0;
        };

        const reportArray = Object.keys(reportData).map((key) => {
            const report = reportData[key];

            return {
                mesAno: key.split(" ")[0].charAt(0).toUpperCase() + key.split(" ")[0].slice(1),
                receita_bruta: report.receita_bruta || "-",
                receita_liquida: report.receita_liquida || "-",
                custo_venda: report.custo_venda || "-",
                despesas_operacionais: report.despesas_operacionais || "-",
                imposto_sem_resultado: report.imposto_sem_resultado || "-",
                margem_contribuicao: report.margem_contribuicao || "-",
                margem_liquida: report.margem_liquida || "-",
                resultado_liquido: report.resultado_liquido || "-",
                margem_prevista: margemPrevistaPorcent/100,
                monthIndex: getMonthIndex(key)
            };
        });

        reportArray.sort((a, b) => a.monthIndex - b.monthIndex);

        return reportArray.map(({ monthIndex, ...rest }) => rest);
    };

    return (
        <PageContainer title={`Resultado do Projeto ${key}`} actions={actions} >
            {Object.keys(dataFormated).length === 0 ? <h5>Não existe dados para o período selecionado.</h5> :  
            <>
                <Button onClick={exportDataInExcel} className='mb-3'>Exportar</Button>
                <div className='w-25'>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Meta Prevista na venda</th>
                                {margemPrevistaPorcent ?
                                    <th style={{color: '#2977ff'}}> {margemPrevistaPorcent ? `${margemPrevistaPorcent.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}%` : '-'}</th>
                                    :
                                    <th> {margemPrevistaPorcent ? `${margemPrevistaPorcent.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}%` : '-'}</th>
                                }
                            </tr>
                        </thead>
                    </Table>
                </div>
                {Object.keys(dataFormated).length > 0 &&
                <Table striped bordered hover style={{background: "#e1eaf3"}}>
                    <thead>
                        <tr>
                            <th style={{width: "3%"}}></th>
                            <th style={{width: "7%"}}></th>
                            <th style={{width: "10%"}}>Receita Bruta Real</th>
                            <th style={{width: "10%"}}>Receita Líquida Real</th>
                            <th style={{width: "10%"}}>Custo Total Real</th>
                            <th style={{width: "10%"}}>Total em Impostos</th>
                            <th style={{width: "10%"}}>Despesas Operacionais</th>
                            <th style={{width: "10%"}}>
                                Resultado Líquido
                                <span onMouseEnter={() => setVisiblePopup('rl_total')} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                    <FiInfo />
                                    {visiblePopup === 'rl_total' && <div className="hover-popup" style={popupStyle}>Resultado Líquido = Receita Líquida - Custo Total Real - Despesas Operacionais - Imposto s/ Resultado</div>}
                                </span>
                            </th>
                            <th style={{width: "15%"}}>
                                Margem Líquida do Projeto
                                <span onMouseEnter={() => setVisiblePopup('ml_total')} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                    <FiInfo />
                                    {visiblePopup === 'ml_total' && <div className="hover-popup" style={popupStyle}>Margem Líquida = Resultado Líquido / Receita Bruta</div>}
                                </span>
                            </th>
                            <th style={{width: "15%"}}>
                                Margem de Contribuição do Projeto
                                <span onMouseEnter={() => setVisiblePopup('mc_total')} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                    <FiInfo />
                                    {visiblePopup === 'mc_total' && <div className="hover-popup" style={{...popupStyle, left: 'auto', right: '0', transform: 'none'}}>Margem de Contribuição = (Receita Líquida - Custo Total Real) / Receita Líquida</div>}
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(() => {
                            const impostosNF = (Number(totais.receitaBrutaTotal) || 0) - (Number(totais.receitaLiquidaTotal) || 0);
                            const totalImpostos = impostosNF + (Number(totais.impostoSobreResultadosTotal) || 0);
                            return (
                                <tr style={{background: "transparent"}}>
                                    <td style={{width: "3%"}}><strong>Total</strong></td>
                                    <td style={{width: "7%"}}></td>
                                    <td style={{width: "10%"}}><strong>R$ {totais.receitaBrutaTotal ? totais.receitaBrutaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                    <td style={{width: "10%"}}><strong>R$ {totais.receitaLiquidaTotal ? totais.receitaLiquidaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                    <td style={{width: "10%"}}><strong>R$ {totais.custoTotalRealTotal ? totais.custoTotalRealTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                    <td style={{width: "10%"}}><strong>R$ {totalImpostos.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></td>
                                    <td style={{width: "10%"}}><strong>R$ {(Number(totais.despesasOperacionaisTotal) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></td>
                                    <td style={{width: "10%"}}><strong>R$ {totais.resultadoLiquidoTotal != null ? totais.resultadoLiquidoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                    <td style={{width: "15%"}}><strong>{totais.totalMargemLiquida ? totais.totalMargemLiquida.toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 }) : "-"}</strong></td>
                                    <td style={{width: "15%"}}><strong>{totais.totalMargemContribuicao ? totais.totalMargemContribuicao.toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 }) : "-"}</strong></td>
                                </tr>
                            );
                        })()}
                    </tbody>
                </Table>}
                {Object.keys(dataFormated).sort().map((ano) => {
                    const mesesOrdenados = Object.values(dataFormated[ano]).sort((a, b) => {
                        // Extrai ano, mês e dia diretamente da string para evitar problemas de timezone
                        const getDataComparavel = (item) => {
                            const dataString = (item.data_inicio || item.periodo_inicial || '').toString();
                            const partes = dataString.split('-');
                            if (partes.length >= 2) {
                                const ano = parseInt(partes[0], 10) || 0;
                                const mes = parseInt(partes[1], 10) || 0;
                                const dia = partes[2] ? parseInt(partes[2].split('T')[0], 10) || 0 : 0;
                                return ano * 10000 + mes * 100 + dia;
                            }
                            return 0;
                        };
                        
                        const dataA = getDataComparavel(a);
                        const dataB = getDataComparavel(b);
                        return dataA - dataB;
                    });

                    return (
                        <div key={ano}>
                            <h5><b>Ano: </b>{ano}</h5>
                            <Table className="mr-5" striped bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{width: "3%"}}>#</th>
                                        <th style={{width: "7%"}}>Mês</th>
                                        <th style={{width: "10%"}}>Receita Bruta Real</th>
                                        <th style={{width: "10%"}}>Receita Líquida Real</th>
                                        <th style={{width: "10%"}}>Custo Total Real</th>
                                        <th style={{width: "10%"}}>Total em Impostos</th>
                                        <th style={{width: "10%"}}>Despesas Operacionais</th>
                                        <th style={{width: "10%"}}>
                                            Resultado Líquido
                                            <span onMouseEnter={() => setVisiblePopup(`rl_${ano}`)} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                                <FiInfo />
                                                {visiblePopup === `rl_${ano}` && <div className="hover-popup" style={popupStyle}>Resultado Líquido = Receita Líquida - Custo Total Real - Despesas Operacionais - Imposto s/ Resultado</div>}
                                            </span>
                                        </th>
                                        <th style={{width: "15%"}}>
                                            Margem Líquida Mensal
                                            <span onMouseEnter={() => setVisiblePopup(`ml_${ano}`)} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                                <FiInfo />
                                                {visiblePopup === `ml_${ano}` && <div className="hover-popup" style={popupStyle}>Margem Líquida = Resultado Líquido / Receita Bruta</div>}
                                            </span>
                                        </th>
                                        <th style={{width: "15%"}}>
                                            Margem de Contribuição Mensal
                                            <span onMouseEnter={() => setVisiblePopup(`mc_${ano}`)} onMouseLeave={() => setVisiblePopup(null)} className="ml-1 info-icon" style={{ position: 'relative', cursor: 'pointer' }}>
                                                <FiInfo />
                                                {visiblePopup === `mc_${ano}` && <div className="hover-popup" style={{...popupStyle, left: 'auto', right: '0', transform: 'none'}}>Margem de Contribuição = (Receita Líquida - Custo Total Real) / Receita Líquida</div>}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mesesOrdenados.map((item, index) => {
                                        let mesLabel = '';
                                        if (item.data_inicio || item.periodo_inicial) {
                                            const dataString = (item.data_inicio || item.periodo_inicial).toString();
                                            const [ano, mes] = dataString.split('-');
                                            const dateCorrect = new Date(Date.UTC(parseInt(ano, 10), parseInt(mes, 10) - 1));
                                            mesLabel = dateCorrect.toLocaleString('pt-BR', { month: 'long', year: 'numeric', timeZone: 'UTC' });
                                        } else {
                                            mesLabel = '-';
                                        }
                                        const rbMes = parseFloat(item.receita_bruta) || 0;
                                        const rlMes = parseFloat(item.receita_liquida) || 0;
                                        const totalImpostosMes = (rbMes - rlMes) + (parseFloat(item.imposto_sem_resultado) || 0);
                                        const despesasOpMes = parseFloat(item.despesas_operacionais) || 0;
                                        return (
                                            <tr key={index}>
                                                <td style={{width: "3%"}}>{index + 1}</td>
                                                <td style={{width: "7%"}}>{mesLabel}</td>
                                                <td style={{width: "10%"}}>{item.receita_bruta !== "-" ? `R$ ${rbMes.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : item.receita_bruta}</td>
                                                <td style={{width: "10%"}}>{item.receita_liquida !== "-" ? `R$ ${rlMes.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : item.receita_liquida}</td>
                                                <td style={{width: "10%"}}>{item.custo_venda !== "-" ? `R$ ${parseFloat(item.custo_venda).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : item.custo_venda}</td>
                                                <td style={{width: "10%"}}>R$ {totalImpostosMes.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                                                <td style={{width: "10%"}}>R$ {despesasOpMes.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                                                <td style={{width: "10%"}}>{item.resultado_liquido !== "-" ? `R$ ${parseFloat(item.resultado_liquido).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : item.resultado_liquido}</td>
                                                <td style={{width: "15%"}}>{item.margem_liquida !== "-" ? parseFloat(item.margem_liquida).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 }) : item.margem_liquida}</td>
                                                <td style={{width: "15%"}}>{item.margem_contribuicao !== "-" ? parseFloat(item.margem_contribuicao).toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 }) : item.margem_contribuicao}</td>
                                            </tr>
                                        );
                                    })}
                                    {(() => {
                                        const ta = totaisPorAno[ano] || {};
                                        const impostosNFAno = (Number(ta.receitaBrutaTotal) || 0) - (Number(ta.receitaLiquidaTotal) || 0);
                                        const totalImpostosAno = impostosNFAno + (Number(ta.impostoSobreResultadosTotal) || 0);
                                        return (
                                            <tr>
                                                <td style={{width: "3%"}}><strong>Total</strong></td>
                                                <td style={{width: "7%"}}></td>
                                                <td style={{width: "10%"}}><strong>R$ {ta.receitaBrutaTotal ? ta.receitaBrutaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                                <td style={{width: "10%"}}><strong>R$ {ta.receitaLiquidaTotal ? ta.receitaLiquidaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                                <td style={{width: "10%"}}><strong>R$ {ta.totalCustoVenda ? ta.totalCustoVenda.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                                <td style={{width: "10%"}}><strong>R$ {totalImpostosAno.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></td>
                                                <td style={{width: "10%"}}><strong>R$ {(Number(ta.despesasOperacionaisTotal) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></td>
                                                <td style={{width: "10%"}}><strong>R$ {ta.resultadoLiquidoTotal != null ? ta.resultadoLiquidoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : "-"}</strong></td>
                                                <td style={{width: "15%"}}><strong>{ta.totalMargemLiquida !== undefined ? ta.totalMargemLiquida.toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 }) : "-"}</strong></td>
                                                <td style={{width: "15%"}}><strong>{ta.totalMargemContribuicao !== undefined ? ta.totalMargemContribuicao.toLocaleString('pt-BR', { style: 'percent', minimumFractionDigits: 2 }) : "-"}</strong></td>
                                            </tr>
                                        );
                                    })()}
                                </tbody>
                            </Table>
                        </div>
                    );
                })}
                {Object.keys(dataFormated).length > 1 && (
                    <div className="w-100 d-flex justify-content-center mt-5 mb-1">
                        <select 
                            style={{
                                padding: "8px 16px", 
                                borderRadius: "10px", 
                                border: "1px solid #555", 
                                color: "#555",
                                background: "transparent",
                                cursor: "pointer"
                            }} 
                            value={selectedYear} 
                            onChange={handleYearChange}
                        >
                            {Object.keys(dataFormated).sort().map(year => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
                {dataFormated[selectedYear] &&
                <>
                <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                        data={dataSelectYear}
                        margin={{
                            top: 20, right: 30, left: 20, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="mesAno" />
                        <YAxis tickFormatter={(value) => `R$ ${value.toLocaleString('pt-br')}`}  />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend />
                        <Bar dataKey="receita_liquida" fill="#00c49f" name="Receita Líquida Real" />
                        <Bar dataKey="custo_venda" fill="#0088fe" cursor="pointer" name="Custo Total Real" />
                        <Line strokeWidth={0} type="monotone" dataKey="resultado_liquido" name="Margem Líquida" stroke="transparent" dot={false} legendType="none" strokeDasharray="0 100" />
                        <Line strokeWidth={0} dataKey="margem_contribuicao" stroke="transparent" dot={false} legendType="none" />
                        {/* <ReferenceLine dataKey="margem_prevista" label={`${margemPrevistaPorcent}%`} stroke="rgb(199, 177, 8)" /> */}
                    </ComposedChart>
                </ResponsiveContainer>
                <ResponsiveContainer width="100%" id="responsive-grafic-recharts" height={400}>
                    <ComposedChart
                        data={dataSelectYear}
                        margin={{
                            top: 20, right: 30, left: 20, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="mesAno" />
                        <YAxis tickFormatter={(value) => value.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}  />
                        <Tooltip formatter={(value) => Number(value).toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })} />
                        <Legend />
                        <Line strokeWidth={2} type="monotone" dataKey="margem_contribuicao" name="Margem de Contribuição" stroke="#ff7300" />
                        <Line strokeWidth={2} type="monotone" dataKey="margem_liquida" name="Margem Líquida" stroke="rgb(199, 177, 8)" />
                        <Line strokeWidth={2} type="monotone" dataKey="margem_prevista" name="Margem Prevista na venda" stroke="#2977ff" />
                    </ComposedChart>
                </ResponsiveContainer>
                </>
                }
            </>}
        </PageContainer>
    )
}

export default ResultadoAnualProjeto;
